import accountsService from '@/common/api/accounts-service';
import authService from '@/common/api/auth-service';
import contactsService from '@/common/api/contacts-service';
import clinicService from '@/common/api/clinic-service';
import clinicsService from '@/common/api/clinics-service';
import appointmentsService from '@/common/api/appointments-service';
import appointmentService from '@/common/api/appointment-service';
import inventoryService from '@/common/api/inventory-service';
import networkTraversalService from '@/common/api/network-traversal-service';
import rpmOrderService from '@/common/api/rpm-order-service';
import rpmPackageService from '@/common/api/rpm-package-service';
import rpmHistoryService from '@/common/api/rpm-history-service';
import orderFormService from '@/common/api/order-form-service';
import patientsService from '@/common/api/patients-service';
import ftpUsersService from '@/common/api/ftp-users-service';
import countriesService from '@/common/api/countries-service';
import commonService from '@/common/api/common-service';
import messagesService from '@/common/api/messages-service';
import whiteLabelService from '@/common/api/white-label-service';
import providersService from '@/common/api/providers-service';
import timezonesService from '../common/api/timezones-service';
import pharmaciesService from '../common/api/pharmacies-service';
import questionnaireService from '../common/api/questions-service';
import waitingRoomService from '../common/api/waiting-room-service';
import userService from '../common/api/user-service';
import cardService from '../common/api/card-service';
import urgentService from '../common/api/urgent-service';
import rpmPatientService from '../common/api/rpm-patient-service';
import translationsService from '../common/api/translations-service';
import schedulesService from '../common/api/schedules-service';
import inviteService from '../common/api/invite-service';
import reasonsService from '../common/api/reasons-service';
import rpmService from '../common/api/rpm-service';
import emrService from '../common/api/emr';
import metricsService from '../common/api/metrics-service';
import ClassificationDiseases from '../common/api/classification-diseases';
import rpmMessageService from '../common/api/rpm-message-service';
import medicalTestService from '../common/api/medical-test-service';
import ssoService from '../common/api/sso-service';
import departmentsService from '../common/api/departments-service';
import patientsImportService from '../common/api/patients-import-service';
import databaseService from '../common/api/database-service';
import rpmTemplatesService from '../common/api/rpm-templates-service';
import pillarPaymentService from '../common/api/pillar-payment-service';
import subscriptionsService from '../common/api/subscriptions-service';
import globeMedService from '../common/api/globe-med-service';
import supportTicketService from '../common/api/support-ticket-service';
import injuryIntakeService from '../common/api/injury-intake-service';
import prescriptionDmeService from '../common/api/prescription-dme-service';

export default Vue => {
  Vue.prototype.$api = {
    accounts: accountsService,
    auth: authService,
    invite: inviteService,
    clinic: clinicService,
    clinics: clinicsService,
    contacts: contactsService,
    appointments: appointmentsService,
    appointment: appointmentService,
    inventory: inventoryService,
    networkTraversal: networkTraversalService,
    rpmOrder: rpmOrderService,
    rpmPackage: rpmPackageService,
    rpmPatient: rpmPatientService,
    rpmHistory: rpmHistoryService,
    rpmMessage: rpmMessageService,
    orderForm: orderFormService,
    patients: patientsService,
    ftpUsers: ftpUsersService,
    countries: countriesService,
    common: commonService,
    messages: messagesService,
    whiteLabel: whiteLabelService,
    providers: providersService,
    timezones: timezonesService,
    pharmacies: pharmaciesService,
    questionnaire: questionnaireService,
    waitingRoom: waitingRoomService,
    user: userService,
    card: cardService,
    urgent: urgentService,
    translations: translationsService,
    schedules: schedulesService,
    reasons: reasonsService,
    rpm: rpmService,
    emr: emrService,
    medicalTest: medicalTestService,
    classificationDiseases: ClassificationDiseases,
    metrics: metricsService,
    sso: ssoService,
    departments: departmentsService,
    patientsImport: patientsImportService,
    database: databaseService,
    rpmTemplates: rpmTemplatesService,
    pillarPayment: pillarPaymentService,
    subscriptions: subscriptionsService,
    globeMed: globeMedService,
    supportTickets: supportTicketService,
    injuryIntake: injuryIntakeService,
    prescriptionDme: prescriptionDmeService,
  };
};
